import { DictUtil } from 'jczh-ui'

// 增值服务产品分类编号
export const valueAddedCategoryCodeDict = new DictUtil({
  VIP: { label: '标前狗', value: 'vip' }
})

// 增值服务产品生效类型
export const valueAddedEffectTypeDict = new DictUtil({
  NONE: { label: '无', value: 0, unit: '' },
  TIME: { label: '时间', value: 1, unit: '' },
  COUNT: { label: '次数', value: 2, unit: '' }
})

// 增值服务产品编号
export const valueAddedProductCodeDict = new DictUtil({
  MARK_SUBSCRIBE: { label: '标讯订阅', value: 'mark_subscribe' },
  BID_FILE_PREVIEW: { label: '标书预览', value: 'bid_file_preview' },
  REGULAR_VIP: {
    label: '普通标前狗会员',
    value: 'regular_vip',
    alias: 'basic',
    servicePhone: '',
    packageName: '基础会员',
    unitPrice: 1699 // 单价
  },
  ADVANCED_VIP: {
    label: '高级标前狗会员',
    value: 'advanced_vip',
    alias: 'premium',
    servicePhone: '0791-83888190',
    packageName: '高级会员',
    unitPrice: 3600, // 单价
    givePreviewTimes: '6' // 赠送标书预览次数
  },
  DIAMOND_VIP: {
    label: '钻石标前狗会员',
    value: 'diamond_vip',
    alias: 'diamond',
    servicePhone: '0791-83888190',
    packageName: '钻石会员',
    unitPrice: 5800, // 单价
    givePreviewTimes: '10' // 赠送标书预览次数
  },
  DIGITAL_CERTIFICATE_VOUCHER: {
    label: '数字证书抵用券',
    value: 'digital_certificate_voucher'
  },
  COMPANY_PORTRAIT: {
    label: '企业画像',
    value: 'company_portrait'
  },
  NOTICE_EXPORT: {
    label: '数据定制导出',
    value: 'notice_export'
  },
  // 废标项检查
  WASTE_BID_CHECK: {
    label: '废标项检查',
    value: 'waste_bid_check',
    effectType: valueAddedEffectTypeDict.COUNT.value,
    unit: '个',
    hide: true
  }
})

// 增值服务产品期限单位
export const valueAddedDurationUnitDict = new DictUtil({
  HOUR: { label: '小时', value: 1, unitLabel: '小时' },
  DAY: { label: '天', value: 2, unitLabel: '天' },
  WEEK: { label: '周', value: 3, unitLabel: '周' },
  MONTH: { label: '月', value: 4, unitLabel: '个月' },
  YEAR: { label: '年', value: 5, unitLabel: '年' }
})

// 标书预览单独购买
export const valueAddedDocumentPreviewPriceDict = new DictUtil({
  1: { label: '1次', value: 1, price: '199.00', vipPrice: '100.00' },
  2: { label: '3次', value: 2, price: '500.00', vipPrice: '200.00' },
  3: { label: '10次', value: 3, price: '1600.00', vipPrice: '500.00' }
})

// 增值服务订单状态
export const vasOrderStatusDict = {
  PENDING: { label: '待支付', value: 0 },
  PAID: { label: '已支付', value: 1 },
  REFUND: { label: '已退款', value: 2 },
  OVERDUE: { label: '已失效', value: 3 },
  CANCEL: { label: '已取消', value: 4 }
}
